







































import {
  Component,
  mixins,
  namespace,
  Prop,
  Watch,
} from 'nuxt-property-decorator'
import { VPopover } from 'v-tooltip'
import { mdiInformationOutline } from '@mdi/js'
import { IProductAdditionalService } from '~/assets/interfaces/products'
import MixinGeneral from '~/assets/mixins/general'
import { filterPrice } from '~/assets/filters/price'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentFormCheckbox from '~/components/form/checkbox.vue'

const siteStore = namespace('site')

@Component({
  components: {
    ComponentFormCheckbox,
    ComponentIcon,
    VPopover,
  },
  filters: {
    filterPrice,
  },
})
export default class ComponentProductAdditionalServices extends mixins(
  MixinGeneral
) {
  @Prop({ type: Array, default: () => [] })
  private services!: IProductAdditionalService[]

  @siteStore.Getter('getOptionsCurrency') private getOptionsCurrency!: string

  @Watch('services', { deep: true, immediate: true })
  private servicesHandler(val: IProductAdditionalService[]) {
    this.items = JSON.parse(JSON.stringify(val))
  }

  @Watch('items', { deep: true, immediate: true })
  private itemsHandler(val: IProductAdditionalService[]) {
    this.$emit('change', val)
  }

  private mdiInformationOutline = mdiInformationOutline

  private items: IProductAdditionalService[] = []
}
